import Vue from 'vue'
import Buefy from 'buefy'
import * as VueComponentsModule from '@ctvoicer/vuecomponents'

// Folha de estilos base (customizacoes CTVoicer + Bulma Core). O pacote declara
// `main: dist/ctstyle.css`, mas nao versiona o dist/, entao importamos o fonte
// SCSS — o webpack resolve o `~bulma` no node_modules desta app. Sem isto a
// aplicacao renderiza sem nenhum estilo de layout.
import '@ctvoicer/ctstyle/src/ctstyle.scss'

// Depois do ctstyle, para que os estilos dos componentes tenham precedencia.
import '@ctvoicer/vuecomponents/dist/vue-components.css'

// O bundle do pacote é UMD sem `libraryExport: 'default'`, então o plugin sai
// em `.default` em vez da raiz do module.exports. O interop do webpack não
// desembrulha porque o `__esModule` só é definido dentro do factory UMD, depois
// da atribuição. Aceitamos as duas formas para não depender do formato do build.
const VueComponents = VueComponentsModule.default || VueComponentsModule

const options = {}

const buefyOptions = {
  defaultIconPack: 'fas',
  defaultDialogCancelText: 'Cancelar',
  defaultDayNames: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  defaultMonthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
}

// Ate a versao 0.4 o proprio @ctvoicer/vuecomponents instalava o Buefy a partir
// destas opcoes; da 1.x em diante ele so registra os componentes Ct*, e o Buefy
// passou a ser responsabilidade da aplicacao. Sem isto os <b-field>/<b-input>
// usados dentro do CtLoginForm nao resolvem.
Vue.use(Buefy, buefyOptions)

Vue.use(VueComponents, { options, buefyOptions })
